module.exports = __webpack_public_path__ + "static/media/cloud-computing.06a4bb06.svg";